import qs from "qs-lite";
import { useMutation, useQuery, useQueryClient } from "react-query";

import api from "../../utils/api";
import { invalidate } from "../../helpers/clientHelper";
import { useHubSnackBar } from "../useSnackBar";

const ROUTING = "/workorderrouting";
const DISPLAY = "/display";
const LABOR = "/labor";

const getVendorWorkOrders = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${ROUTING}/vendors?${queryString}`);
};
export const useVendorGetWorkOrders = ({ defaultLocation = 1 }) => {
  const query = new URLSearchParams(window.location.search);

  const location = query.get("location") || defaultLocation;

  const orderBy = query.get("orderBy") || "plannedStartDate";
  const sortOrder = query.get("sortOrder") || "desc";
  const limit = query.get("limit") || 50;
  const offset = query.get("offset") || 0;

  const stationIds = query.get("stations");
  const startDate = query.get("startDate");

  const queryProps = {
    location: Number(location),
    limit,
    offset,
    orderBy,
    sortOrder,
    ...(stationIds && { stationIds }),
    ...(startDate && { startDate }),
  };

  return useQuery(
    [ROUTING, { ...queryProps }, "vendors"],
    getVendorWorkOrders,
    {
      retry: false,
    }
  );
};

const getWorkOrderRouting = ({ queryKey }) => {
  const [path] = queryKey;
  return api.get(path);
};
export const useGetWorkOrderRoutingData = (workOrder) => {
  return useQuery([`${ROUTING}/${workOrder}`], getWorkOrderRouting, {
    retry: false,
    enabled: !!workOrder,
  });
};

const getWorkOrderRoutingByRoute = ({ queryKey }) => {
  const [_, routeId] = queryKey;
  return api.get(`${ROUTING}/subroute/${routeId}`);
};
export const useGetWorkOrderRoutingRoute = (routeId) => {
  return useQuery([ROUTING, routeId, "/route"], getWorkOrderRoutingByRoute, {
    retry: false,
    enabled: typeof routeId === "number",
  });
};

const getWorkOrderRoutingByGroup = ({ queryKey }) => {
  const [_, groupId] = queryKey;
  return api.get(`${ROUTING}/subroute/group/${groupId}`);
};
export const useGetWorkOrderRoutingGroup = (groupId) => {
  return useQuery([ROUTING, groupId], getWorkOrderRoutingByGroup, {
    retry: false,
    enabled: typeof groupId === "number",
  });
};

const postCreateSubRoute = (data) => {
  const routeId = data?.routeId;
  delete data.routeId;
  return api.post(`${ROUTING}/subroute/${routeId}`, data);
};
export const usePostCreateSubRoute = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateSubRoute, {
    onSuccess: () => {
      invalidate(queryClient, DISPLAY);
      invalidate(queryClient, LABOR);
      invalidate(queryClient, ROUTING);
      addSnackbarSuccess({ message: "Successfully Created Subroute" });
    },
  });
};

const putUpdateSubRouteGroup = (data) => {
  const groupId = data?.groupId;
  delete data.groupId;
  return api.put(`${ROUTING}/subroute/group/${groupId}`, data);
};
export const usePutUpdateSubRouteGroup = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putUpdateSubRouteGroup, {
    onSuccess: () => {
      invalidate(queryClient, DISPLAY);
      invalidate(queryClient, LABOR);
      invalidate(queryClient, ROUTING);
      addSnackbarSuccess({ message: "Successfully Updated Group" });
    },
  });
};
